export class tblMap {
    ID: number = 0;
    Name: string = "";
    URL: string = "";
    IsChecked: boolean = false;
    Restricted: boolean = false;
    TypeID:number;
    TypeName:string;
    MapType:string;
}